import React from "react";
import { marqueeItems } from "../data/landing";
export function Marquee() {
  const items = [...marqueeItems, ...marqueeItems];
  return <div className="mq" aria-hidden="true" data-id="element-100" data-mp="2nhfmxxwuooby">
      <div data-id="element-101" data-mp="2ije33arlokzf">
        {items.map((item, i) => <React.Fragment key={i} data-id="element-102" data-mp="2ik70hl4o5y4w" data-mpi={i}>
            {item}&nbsp;&nbsp;&nbsp;{" "}
          </React.Fragment>)}
      </div>
    </div>;
}